import React, { useEffect, useState, useCallback } from "react";
import { Api_Token } from "../../util/Api"; // Replace with your API token logic
import {
  Box,
  Table,
  TableBody,
  TableContainer,
  TableHead,
  Card,
  TablePagination,
  Button,
  IconButton,
  CardActions,
  Grid,
  CardContent,
  Pagination,
} from "@mui/material";
import EditIcon from "@mui/icons-material/Edit";
import DeleteIcon from "@mui/icons-material/Delete";
import ModelJourney from "../../components/popup/ModelCaisseJoureny";
import CustomAlert from "../../components/Alert/AlertCustomer";
import DeleteConfirmation from "../../components/popup/deleteConfirmation";
import Indexdasboard from "../../components/dashboard/IndexDashbord";
import { useNavigate, useParams } from "react-router";
import { StyledTableCell, StyledTableRow } from "../../assets/style/Table";
import TitreGraphik from "../../components/Typography/TitreGraphik";
import { Link } from "react-router-dom";
import { useTranslation } from "react-i18next";
import NumericFormatEnv from "../../components/Numeric/NumericFormatEnv";
import LabelTypography from "../../components/Typography/LabelTypography";
import CancelIcon from "@mui/icons-material/Cancel";

function CaisseJourneysPage() {
  return <Indexdasboard Children={<CaisseJourneys />} />;
}

const CaisseJourneys = () => {
  const { idCaisse } = useParams();
  const { t } = useTranslation();
  const navigate = useNavigate();
  const [journeys, setJourneys] = useState();
  const [page, setPage] = useState(0);
  const [rowsPerPage, setRowsPerPage] = useState(10);
  const [totalCount, setTotalCount] = useState(0);

  const [AlertEtat, setAlertEtat] = useState("inisial");
  const [AlertMessage, setAlertMessage] = useState("");

  const [openModal, setOpenModal] = useState(false);
  const [openDeleteDialog, setOpenDeleteDialog] = useState(false);
  const [openCloseDialog, setOpenCloseDialog] = useState(false);
  const [journeyToDelete, setJourneyToDelete] = useState(null);
  const [formData, setFormData] = useState({
    montantDepart: "",
    dateOpen: "",
    dateClose: "",
  });
  const [error, setError] = useState(null);

  const fetchJourneys = useCallback(
    async (currentPage, rowsPerPage) => {
      try {
        const response = await Api_Token.get(
          `/CaisseJourney/getJourneysByCaisse/${idCaisse}?page=${
            currentPage + 1
          }&perPage=${rowsPerPage}`
        );
        setJourneys(response.data.data);
        setTotalCount(response.data.total);
      } catch (error) {
        console.error("Error fetching journeys:", error);
      }
    },
    [idCaisse]
  );

  const handleCloseCaisse = () => {
    Api_Token.post(`CaisseJourney/closeCaisseWithStore/${idCaisse}`)
      .then(() => {
        //alert(t("Caisse closed successfully!"));
        setAlertEtat("succes");
        setAlertMessage(t("Caisse closed successfully!"));
      })
      .catch((error) => {
        setAlertEtat("error");
        setAlertMessage(t("Failed to close the caisse."));
        console.error("Error closing caisse:", error);
      });
  };
  useEffect(() => {
    fetchJourneys(page, rowsPerPage);
  }, [fetchJourneys, page, rowsPerPage]);

  const handleDeleteJourney = async () => {
    try {
      await Api_Token.delete(`/CaisseJourney/destroy/${journeyToDelete.id}`);
      setAlertEtat("success");
      setAlertMessage(t("Journey deleted successfully!")); // استخدم الترجمة
      fetchJourneys(page, rowsPerPage);
      handleCloseDeleteDialog();
    } catch (error) {
      setAlertEtat("error");
      setAlertMessage(t("Error deleting journey:") + " " + error.message); // استخدم الترجمة
    }
  };

  const handleSubmit = async () => {
    const openDate = new Date(formData.dateOpen);
    const closeDate = new Date(formData.dateClose);

    if (openDate > closeDate) {
      setError(t("Opening date cannot be after closing date.")); // استخدم الترجمة
      return;
    }
    try {
      if (formData.id) {
        await Api_Token.put(`/CaisseJourney/update/${formData.id}`, formData);
        setAlertEtat("success");
        setAlertMessage(t("Journey updated successfully!")); // استخدم الترجمة
      } else {
        await Api_Token.post(`/CaisseJourney/newCaisseJourney`, {
          ...formData,
          idCaisse,
        });
        setAlertEtat("success");
        setAlertMessage(t("Journey created successfully!")); // استخدم الترجمة
      }
      fetchJourneys(page, rowsPerPage);
      handleCloseModal();
    } catch (error) {
      setAlertEtat("error");
      setAlertMessage(t("Error submitting form:") + " " + error.message); // استخدم الترجمة
    }
  };

  const handleChangePage = (event, newPage) => {
    setPage(newPage);
  };

  const handleChangeRowsPerPage = (event) => {
    setRowsPerPage(parseInt(event.target.value, 10));
    setPage(0);
  };

  const handleOpenModal = (
    journey = { montantDepart: "", dateOpen: "", dateClose: "" }
  ) => {
    setFormData(journey);
    setOpenModal(true);
  };

  const handleCloseModal = () => {
    setOpenModal(false);
    setError(null);
  };

  const handleOpenDeleteDialog = (journey) => {
    setJourneyToDelete(journey);
    setOpenDeleteDialog(true);
  };

  const handleCloseDeleteDialog = () => {
    setOpenDeleteDialog(false);
    setJourneyToDelete(null);
  };

  return (
    <Box>
      <TitreGraphik>
        <span onClick={() => navigate(-1)}>⬅</span>
        {t("gestion caisses")}
      </TitreGraphik>
      <Box sx={{ display: { xs: "none", md: "flex" } }}>
        <Card sx={{ padding: "2%", marginTop: "2%", width: "100%" }}>
          <Button variant="contained" onClick={() => handleOpenModal()}>
            {t("Add New Journey")}
          </Button>
          <TableContainer sx={{ marginTop: "20px" }}>
            <Table sx={{ minWidth: 650 }} aria-label="journeys table">
              <TableHead>
                <StyledTableRow>
                  <StyledTableCell align="center">{t("ID")}</StyledTableCell>{" "}
                  <StyledTableCell align="center">
                    {t("Montant Depart")}
                  </StyledTableCell>
                  <StyledTableCell align="center">
                    {t("Solde actuel")}
                  </StyledTableCell>
                  <StyledTableCell align="center">
                    {t("Date Open")}
                  </StyledTableCell>
                  <StyledTableCell align="center">
                    {t("Date Close")}
                  </StyledTableCell>
                  <StyledTableCell align="center">
                    {t("Actions")}
                  </StyledTableCell>
                </StyledTableRow>
              </TableHead>
              <TableBody>
                {journeys?.map((journey) => (
                  <StyledTableRow key={journey.id}>
                    <StyledTableCell align="center">
                      <Link
                        to={`/TransactionParCaisse/${journey.id}`}
                        state={{ journey }}
                        style={{ textDecoration: "none", color: "inherit" }}
                      >
                        #{journey.id}
                      </Link>
                    </StyledTableCell>
                    <StyledTableCell align="center">
                      <NumericFormatEnv Number={journey.montantDepart} />
                    </StyledTableCell>
                    <StyledTableCell align="center">
                      <NumericFormatEnv Number={journey.totalMontantCash} />
                    </StyledTableCell>
                    <StyledTableCell align="center">
                      {journey.dateOpen}
                    </StyledTableCell>
                    <StyledTableCell align="center">
                      {journey.dateClose}
                    </StyledTableCell>
                    <StyledTableCell align="center">
                      <IconButton onClick={() => handleOpenModal(journey)}>
                        <EditIcon />
                      </IconButton>
                      <IconButton
                        color="error"
                        onClick={() => setOpenCloseDialog(true)}
                      >
                        <CancelIcon />
                      </IconButton>
                      <IconButton
                        color="error"
                        onClick={() => handleOpenDeleteDialog(journey)}
                      >
                        <DeleteIcon />
                      </IconButton>
                    </StyledTableCell>
                  </StyledTableRow>
                ))}
              </TableBody>
            </Table>
            <TablePagination
              rowsPerPageOptions={[5, 10, 25]}
              component="div"
              count={totalCount}
              rowsPerPage={rowsPerPage}
              page={page}
              onPageChange={handleChangePage}
              onRowsPerPageChange={handleChangeRowsPerPage}
            />
          </TableContainer>
        </Card>
      </Box>
      <Box sx={{ display: { xs: "flex", md: "none" } }}>
        <Box sx={{ width: "100%" }}>
          <Grid container spacing={2} sx={{ marginTop: "3%" }}>
            <Grid item xs={12}>
              <Button
                variant="contained"
                onClick={() => handleOpenModal()}
                fullWidth
              >
                {t("Add New Journey")}
              </Button>
            </Grid>
            {journeys?.map((journey) => (
              <Grid item xs={12} sm={6} md={4} key={journey.id}>
                <Card sx={{ minWidth: 275, padding: "10px" }}>
                  <CardContent>
                    <LabelTypography variant="h6" align="center">
                      <Link
                        to={`/TransactionParCaisse/${journey.id}`}
                        state={{ journey }}
                        style={{ textDecoration: "none", color: "inherit" }}
                      >
                        #{journey.id}
                      </Link>
                    </LabelTypography>
                    <LabelTypography variant="body1" align="center">
                      Montant Départ:{" "}
                      <NumericFormatEnv Number={journey.montantDepart} />
                    </LabelTypography>
                    <LabelTypography variant="body1" align="center">
                      Solde actuel:{" "}
                      <NumericFormatEnv Number={journey.totalMontantCash} />
                    </LabelTypography>
                    <LabelTypography variant="body2" align="center">
                      Date Open: {journey.dateOpen}
                    </LabelTypography>
                    <LabelTypography variant="body2" align="center">
                      Date Close: {journey.dateClose}
                    </LabelTypography>
                  </CardContent>
                  <CardActions sx={{ justifyContent: "center" }}>
                    <IconButton onClick={() => handleOpenModal(journey)}>
                      <EditIcon />
                    </IconButton>
                    <IconButton
                      color="error"
                      onClick={() => setOpenCloseDialog(true)}
                    >
                      <CancelIcon />
                    </IconButton>
                    <IconButton
                      color="error"
                      onClick={() => handleOpenDeleteDialog(journey)}
                    >
                      <DeleteIcon />
                    </IconButton>
                  </CardActions>
                </Card>
              </Grid>
            ))}
            <Grid item xs={12}>
              <Box
                sx={{
                  marginTop: "3%",
                  display: "flex",
                  justifyContent: "center",
                }}
              >
                <Pagination
                  count={Math.ceil(totalCount / rowsPerPage)}
                  onChange={(event, newPage) => {
                    setPage(newPage - 1); // Adjust for 0-based indexing
                  }}
                  variant="outlined"
                  color="primary"
                />
              </Box>
            </Grid>
          </Grid>
        </Box>
      </Box>
      <ModelJourney
        open={openModal}
        onClose={handleCloseModal}
        formData={formData}
        setFormData={setFormData}
        handleSubmit={handleSubmit}
        error={error}
      />
      <DeleteConfirmation
        open={openDeleteDialog}
        onClose={handleCloseDeleteDialog}
        message={`Etes-vous sûr de vouloir supprimer la caisse ?`}
        confirme={handleDeleteJourney}
        titre="delete"
      />
      <DeleteConfirmation
        open={openCloseDialog}
        onClose={() => setOpenCloseDialog(false)}
        message={`Etes-vous sûr de vouloir fermer la caisse ?`}
        confirme={handleCloseCaisse}
        titre="close"
      />
      <CustomAlert
        open={AlertEtat !== "inisial"}
        onClose={() => {
          setAlertEtat("inisial");
        }}
        etat={AlertEtat}
        message={AlertMessage}
      />
    </Box>
  );
};

export default CaisseJourneysPage;
